export function ensureNonZeroNumber<TFallback>(value: unknown, fallback: TFallback): number | TFallback {
    if (typeof value === 'number' && !Number.isNaN(value) && value !== 0) {
        return value;
    }

    const numberValue = Number(value);

    if (typeof value === 'string' && value.trim() !== '' && !Number.isNaN(numberValue) && numberValue !== 0) {
        return numberValue;
    }

    return fallback;
}
